import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const equipRouter = {
  path: '/adminManage',
  redirect: 'noredirect',
  name: 'adminManage',
  component: Layout,
  meta: {
    title: '管理员信息管理',
    icon: 'adminmanage'
  },
  children: [
    {
      path: 'expertmanage',
      component: () => import('@/views/adminManage/expertmanage/index.vue'),
      name: 'expertmanage',
      meta: {
        title: '点评员管理',
        icon: 'expert',
        requireAuth: true
      }
    },
  ]
}

export default equipRouter
